var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.213 4.57l1.1 1.1c.644.643.644 1.394 0 2.038L5.945 9.076c-.134.107-.134.214-.08.375.295.724.75 1.395 1.26 2.012.993 1.234 2.147 2.333 3.489 3.165.295.188.617.322.912.482.161.08.269.054.376-.08.456-.483.912-.939 1.395-1.395.618-.617 1.369-.617 1.986 0 .752.751 1.503 1.502 2.254 2.226.617.617.617 1.395 0 2.039-.43.43-.885.831-1.261 1.287-.59.644-1.315.859-2.147.805-1.207-.054-2.334-.483-3.435-.992a18.714 18.714 0 01-6.171-4.828c-1.261-1.502-2.335-3.165-3.006-5.016-.322-.912-.563-1.824-.51-2.79.054-.59.269-1.1.725-1.529.483-.456.94-.938 1.395-1.394.618-.59 1.369-.59 1.986 0 .349.375.724.751 1.1 1.126h0z",
    strokeWidth: 2,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 9.928a10.81 10.81 0 00-3.039-5.844A10.809 10.809 0 0010.775 1l-.217 1.46c2.035.298 3.88 1.191 5.345 2.652a9.45 9.45 0 012.632 5.032L20 9.928zM16.147 10.199c-.217-1.326-.868-2.544-1.818-3.518a6.692 6.692 0 00-3.717-1.866l-.217 1.46c1.113.163 2.09.65 2.876 1.434.76.758 1.248 1.678 1.411 2.733l1.465-.243z",
    strokeWidth: 0.5,
    fill: "currentColor"
  }))));
}
export default SvgPhone;